export default __webpack_public_path__ + "static/media/right.eda6d08a.svg";